import { render, staticRenderFns } from "./OrderHistory.vue?vue&type=template&id=08158ecb&scoped=true&"
import script from "./OrderHistory.vue?vue&type=script&lang=ts&"
export * from "./OrderHistory.vue?vue&type=script&lang=ts&"
import style0 from "./OrderHistory.vue?vue&type=style&index=0&id=08158ecb&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08158ecb",
  null
  
)

export default component.exports